var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"min-h-full"},[_c('v-top-toolbar',{attrs:{"title":"Participants","showBack":true}}),(_vm.sharedoId)?_c('participants',{attrs:{"id":_vm.sharedoId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }